import React, { type ForwardedRef, forwardRef, useContext } from 'react';
import { useFelaEnhanced } from '@ackee/fela';
import { FormattedMessage } from 'react-intl';

import { DynamicContainer, ContainerType, LazyLoadContainer, Title, Text, TitleTypes, TextTypes } from 'modules/ui';
import { PixelatedBackgroundContext, BackgroundMode } from 'modules/homepage';

import { SingleOffice } from './SingleOffice';
import { offices } from '../constants';

import * as felaRules from './Offices.rules';

interface OfficesProps {
    lazyLoaded?: boolean;
}

export const Offices = forwardRef(({ lazyLoaded = false }: OfficesProps, ref: ForwardedRef<HTMLElement>) => {
    const backgroundMode = useContext(PixelatedBackgroundContext);
    const { rules } = useFelaEnhanced(felaRules, { backgroundMode });

    return (
        <DynamicContainer ref={ref} as={ContainerType.SECTION}>
            <LazyLoadContainer lazyLoaded={lazyLoaded}>
                <DynamicContainer
                    extend={{ container: felaRules.extendContainer }}
                    isFluid
                    type={ContainerType.GRID}
                    backgroundMode={backgroundMode}
                >
                    {/* @ts-expect-error */}
                    <Text
                        columns={12}
                        type={TextTypes.SECTION}
                        extend={{ text: rules.extendTitleSection }}
                        backgroundMode={backgroundMode}
                    >
                        <FormattedMessage id="homepage.contact.sectionTitle" />
                    </Text>
                    <DynamicContainer columns={4}>
                        {/* @ts-expect-error */}
                        <Title
                            as={TitleTypes.H2}
                            type={TitleTypes.H3}
                            extend={{ title: rules.extendTitle }}
                            backgroundMode={backgroundMode}
                        >
                            <FormattedMessage id="contacts.section.title" />
                        </Title>
                        <svg
                            width="513"
                            height="15"
                            viewBox="0 0 513 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 1L14 14H512.5"
                                stroke={backgroundMode === BackgroundMode.Dark ? 'white' : 'black'}
                                strokeWidth="2"
                            />
                        </svg>
                    </DynamicContainer>
                    <DynamicContainer
                        columns={8}
                        extend={{ container: felaRules.extendOfficeContainer }}
                        backgroundMode={backgroundMode}
                    >
                        {offices.map(office => (
                            <SingleOffice key={office.title} content={office} />
                        ))}
                    </DynamicContainer>
                </DynamicContainer>
            </LazyLoadContainer>
        </DynamicContainer>
    );
});
